module.exports = "pegasus/assets/theme5/header-image.jpg";